import { useState, useContext, createContext, FC, useEffect } from 'react';
import GlobalContext from './GlobalContext';

import { EQueryStringParam, EThirdPartyProvider } from '../util/constants';
import { useLocation } from 'react-router-dom';

export type TThirdPartyLoginContext = {
    thirdPartyLoginUiState: EThirdPartyLoginUiState;
    userId: string;
    loginProvider: EThirdPartyProvider;
};

export enum EThirdPartyLoginUiState {
    default,
    ready,
}

const ThirdPartyLoginContext = createContext<TThirdPartyLoginContext | undefined>(undefined);

export const ThirdPartyLoginProvider: FC = ({ children }) => {
    const { getFullLoginLinkFromLocalStorage } = useContext(GlobalContext);
    const [thirdPartyLoginUiState, setThirdPartyLoginUiState] = useState(EThirdPartyLoginUiState.default);
    const [userId, setUserId] = useState('');
    const [loginProvider, setLoginProvider] = useState<EThirdPartyProvider | null>(null);
    const { search: queryParams } = useLocation();

    const parseQueryString = () => {
        const params = new URLSearchParams(queryParams);
        const userId = params.get(EQueryStringParam.userId);
        const provider = params.get(EQueryStringParam.provider) as EThirdPartyProvider;
        userId && setUserId(userId);
        provider && setLoginProvider(provider);
    };

    const getInitialData = () => {
        // full login link put in local storage on initital login
        getFullLoginLinkFromLocalStorage();
        parseQueryString();
        setThirdPartyLoginUiState(EThirdPartyLoginUiState.ready);
    };

    useEffect(() => {
        if (thirdPartyLoginUiState === EThirdPartyLoginUiState.default) {
            getInitialData();
        }
    }, [thirdPartyLoginUiState]);

    return (
        <ThirdPartyLoginContext.Provider
            value={{
                thirdPartyLoginUiState,
                userId,
                loginProvider,
            }}
        >
            {children}
        </ThirdPartyLoginContext.Provider>
    );
};

export default ThirdPartyLoginContext;
